import React, { useContext } from 'react';
import { SiteHeader as Header } from '@buzzfeed/react-components';
import BuzzContext from '../../contexts/buzz';
import StickyContext from '../../contexts/sticky';

function SiteHeader({ renderHeaderAboveAd, ...header }) {
  const { destination_name } = useContext(BuzzContext).buzz;
  const stickyContext = useContext(StickyContext);
  const headerProps = { ...header };
  if (destination_name === 'buzzfeed_news' || !renderHeaderAboveAd) {
    headerProps.stickyHeaderClass = '';
  }

  return (
    <Header {...headerProps} stickyRegistry={stickyContext} />
  );
}

export default SiteHeader;
